const numberFieldInputAsNumber = (input: number) => {
  if (Number.isNaN(input)) {
    return 0;
  }
  return input;
};

export const calculateAvailableStockFromFormInput = (input: {
  stock: number;
  incomingStock: number;
  committedStock: number;
}) => {
  const stock = numberFieldInputAsNumber(input.stock);
  const incomingStock = numberFieldInputAsNumber(input.incomingStock);
  const committedStock = numberFieldInputAsNumber(input.committedStock);

  return incomingStock + stock - committedStock;
};
